export const intlMessages: any = {
  en: {
    login: "Login",
    username: "Username",
    password: "Password",
  },
  es: {
    login: "Acceso",
    username: "Nombre de usuario",
    password: "Contraseña",
  },
};
